<!-- Method, only when the Driver is Patient -->
<div class="forecast-table-grid-select-container">
  <ng-select
    #dropdown
    class="forecast-table-grid-select"
    [searchable]="false"
    [clearable]="false"
    (open)="onDropdownOpen()"
    (close)="onDropdownClose()"
    [appendTo]="'ag-grid-angular'"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [auxTooltip]="tooltip"
    [ngClass]="{ 'is-invalid': isInvalid }"
    [(ngModel)]="selectedPatientCurve"
  >
    <ng-option
      *ngFor="let item of patientCurves; index as index; let first = first"
      [value]="item.value"
    >
      {{ item.name }}
    </ng-option>
    <ng-template ng-footer-tmp class="flex flex-col">
      <div class="items-wrapper grow">
        <ng-option
          [value]="item.value"
          *ngFor="let item of patientCurves; let first = first; let last = last"
        >
          <div
            *ngIf="item.showLine && !first"
            class="border-b h-1 border-aux-gray-darkest my-1 mx-1"
          ></div>
          <div
            class="relative flex justify-between cursor-pointer select-none py-3 pl-3 -mx-2 option-font"
            [class.selected-item]="selectedPatientCurve === item.value"
            [class.first-item]="first"
            [class.last-item]="last"
            [class.hover-item]="selectedPatientCurve !== item.value"
            (click)="select(item.value); dropdown.close()"
          >
            <div class="flex-1">
              {{ item.name }}
            </div>
            <span
              stroke-width="2.25"
              class="checkmark w-5 h-5 mr-2"
              *ngIf="dropdownOpen && selectedPatientCurve === item.value"
              inlineSVG="check.svg"
            ></span>
          </div>
        </ng-option>
      </div>
    </ng-template>
  </ng-select>
</div>
